import Lenis from 'lenis';

let lenisInstance = null;

export const getLenis = () => lenisInstance;

export const lenis = () => {
    lenisInstance = new Lenis({
        duration: 1.3,
        smooth: true,
        prevent: node =>
            node.classList?.contains('hero-movie') ||
            node.closest?.(
                '[data-lenis-prevent], [data-scroll-lock-panel], .minicart-sidebar__body, .listing__filters-sidebar-body, [js-map-shell], [js-map-wrapper]'
            ),
    });

    function raf(time) {
        lenisInstance.raf(time);
        requestAnimationFrame(raf);
    }

    requestAnimationFrame(raf);
};
